export const eventsData = [
  {
    id: 1,
    title: { en: "APA League Night", fr: "Soirée de Ligue APA" },
    description: { en: "Our premier weekly pool league. Watch the pros or join a team.", fr: "Notre ligue hebdomadaire de premier plan. Regardez les pros ou joignez une équipe." },
    startDate: "2024-01-01",
    endDate: "2025-12-31",
    type: { en: "League", fr: "Ligue" },
    image: "/assets/images/pool-table.jpg"
  },
  {
    id: 2,
    title: { en: "St. Patrick's Day Bash", fr: "Fête de la St-Patrick" },
    description: { en: "Green beer, live music, and special 8-ball challenges all day long.", fr: "Bière verte, musique live et défis spéciaux toute la journée." },
    startDate: "2025-03-17",
    endDate: "2025-03-17",
    type: { en: "Special Event", fr: "Événement spécial" }
  },
  {
    id: 3,
    title: { en: "Amateur 8-Ball Tournament", fr: "Tournoi Amateur 8-Ball" },
    description: { en: "Weekly tournament for casual players. $200 prize pool!", fr: "Tournoi hebdomadaire pour joueurs occasionnels. Prix de 200 $ !" },
    startDate: "2024-05-01",
    endDate: "2025-12-31",
    type: { en: "Tournament", fr: "Tournoi" }
  }
];